/* Bundle Prompt — per-product 2-item bundle toast.
   Eligible products are auto-discovered from the "2-voor-deals" Shopify
   collection via the #bundle-deals-data JSON island (rendered by
   snippets/bundle-deals-data.liquid). Each eligible product is its own
   bundle: adding 1 prompts for a 2nd color of the SAME product; adding 2
   confirms. Other products don't cross-trigger. */

const BUNDLE_MAX = 2;
const TOAST_DURATION = 4000;

const BUNDLE_HANDLES = (() => {
  const el = document.getElementById("bundle-deals-data");
  if (!el) return new Set();
  try {
    return new Set(Object.keys(JSON.parse(el.textContent || "{}")));
  } catch {
    return new Set();
  }
})();

const I18N = (() => {
  const fallback = {
    added: "Added \u2713  Pick a 2nd color for the bundle",
    complete: "Bundle complete \u2713",
  };
  const el = document.getElementById("bundle-prompt-i18n");
  if (!el) return fallback;
  try {
    const parsed = JSON.parse(el.textContent || "{}");
    return { ...fallback, ...parsed };
  } catch {
    return fallback;
  }
})();

class BundlePrompt {
  constructor() {
    this.counts = new Map();
    this._buildToast();
    this._bind();
    this._syncFromCart(false);
  }

  _buildToast() {
    this.toast = document.createElement("div");
    this.toast.className = "bundle-prompt__toast";
    this.toast.setAttribute("role", "status");
    this.toast.setAttribute("aria-live", "polite");
    this.toast.hidden = true;
    document.body.appendChild(this.toast);
  }

  _bind() {
    document.addEventListener("on:cart:loaded", (e) => {
      const detail = e.detail || {};
      this._syncFromCart(detail.type === "ADD");
    });
  }

  _perProductCounts(cart) {
    const map = new Map();
    if (!cart || !Array.isArray(cart.items)) return map;
    for (const item of cart.items) {
      if (BUNDLE_HANDLES.has(item.handle)) {
        map.set(
          item.handle,
          (map.get(item.handle) || 0) + (item.quantity || 0),
        );
      }
    }
    return map;
  }

  async _syncFromCart(detectAdd) {
    try {
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";
      const res = await fetch(`${root}cart.js`, {
        headers: { Accept: "application/json" },
      });
      const cart = await res.json();
      const next = this._perProductCounts(cart);
      if (detectAdd) {
        for (const [handle, qty] of next) {
          const prev = this.counts.get(handle) || 0;
          if (qty > prev) {
            const capped = Math.min(qty, BUNDLE_MAX);
            this._showToast(this._toastMessage(capped));
            break;
          }
        }
      }
      this.counts = next;
    } catch (e) {
      /* noop */
    }
  }

  _toastMessage(count) {
    return count >= BUNDLE_MAX ? I18N.complete : I18N.added;
  }

  _showToast(text) {
    this.toast.textContent = text;
    this.toast.hidden = false;
    requestAnimationFrame(() => this.toast.classList.add("is-visible"));
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => {
      this.toast.classList.remove("is-visible");
      setTimeout(() => {
        this.toast.hidden = true;
      }, 250);
    }, TOAST_DURATION);
  }
}

const init = () => {
  new BundlePrompt();
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
